export const APP_STARTER_TYPE_DEVICE_MANAGER = 'DEVICE_MANAGER_JAR';
export const APP_STARTER_TYPE_STUDY_EDITOR = 'STUDY_EDITOR_JAR';
export const APP_STARTER_TYPE = {
	DEVICE_MANAGER: APP_STARTER_TYPE_DEVICE_MANAGER,
	STUDY_EDITOR: APP_STARTER_TYPE_STUDY_EDITOR,
}
export const APP_STARTER_TYPES = [
	APP_STARTER_TYPE_DEVICE_MANAGER,
	APP_STARTER_TYPE_STUDY_EDITOR,
];